import React from 'react';
import { Tag } from "antd";
import i18next from "i18next";

export const objectStatus = [
  { label: 'Identified', color: 'default', value: 'identified' },
  { label: 'In Progress', color: 'warning', value: 'inProgress' },
  { label: 'Assessed', color: 'blue', value: 'assessed' },
  { label: 'Connected', color: 'success', value: 'connected' },
];
export const defaultObjectStatus = { label: 'Identified', color: 'default', value: 'identified' }

export const getObjectStatus = (status = 'identified') => {
  const sclS = objectStatus.find(s => s.value === status) || defaultObjectStatus;
  return <Tag color={sclS.color}>{i18next.t(sclS.label)}</Tag>
}